<template>
  <div class="swiper_in">
    <div class="home_con">
      <ul class="pages">
        <li v-for="(item, index) in initSize() ? 2 : 4" :key="index">
          <p v-show="activeIndex == index" ref="page_size"></p>
        </li>
      </ul>
      <div class="swiper_pc">
        <div class="swiper-container swiper-no-swiping">
          <div class="home_tit">合作伙伴</div>
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcco/1.png" alt="" /></li>
                <li><img src="@/assets/pcco/2.png" alt="" /></li>
                <li><img src="@/assets/pcco/3.png" alt="" /></li>
                <li><img src="@/assets/pcco/jj.png" alt="" /></li>
                <li><img src="@/assets/pcco/5.png" alt="" /></li>
                <li><img src="@/assets/pcco/6.png" alt="" /></li>
                <li><img src="@/assets/pcco/7.png" alt="" /></li>
                <li><img src="@/assets/pcco/8.png" alt="" /></li>
                <li><img src="@/assets/pcco/9.png" alt="" /></li>
                <li><img src="@/assets/pcco/10.png" alt="" /></li>
                <li><img src="@/assets/pcco/11.png" alt="" /></li>
                <li><img src="@/assets/pcco/12.png" alt="" /></li>
                <li><img src="@/assets/pcco/13.png" alt="" /></li>
                <li><img src="@/assets/pcco/14.png" alt="" /></li>
                <li><img src="@/assets/pcco/15.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcco/16.png" alt="" /></li>
                <li><img src="@/assets/pcco/17.png" alt="" /></li>
                <li><img src="@/assets/pcco/18.png" alt="" /></li>
                <li><img src="@/assets/pcco/19.png" alt="" /></li>
                <li><img src="@/assets/pcco/20.png" alt="" /></li>
                <li><img src="@/assets/pcco/21.png" alt="" /></li>
                <li><img src="@/assets/pcco/22.png" alt="" /></li>
                <li><img src="@/assets/pcco/23.png" alt="" /></li>
                <li><img src="@/assets/pcco/24.png" alt="" /></li>
                <li><img src="@/assets/pcco/25.png" alt="" /></li>
                <li><img src="@/assets/pcco/26.png" alt="" /></li>
                <li><img src="@/assets/pcco/27.png" alt="" /></li>
                <li><img src="@/assets/pcco/28.png" alt="" /></li>
              </ul>
            </div>
          </div>
          <br /><br />
          <!-- 如果需要分页器 -->
          <!-- <div class="swiper-pagination"></div> -->
        </div>
      </div>

      <div class="swiper_mo">
        <div class="swiper-container">
          <div class="home_tit">合作伙伴</div>
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcco/1.png" alt="" /></li>
                <li><img src="@/assets/pcco/2.png" alt="" /></li>
                <li><img src="@/assets/pcco/3.png" alt="" /></li>
                <li><img src="@/assets/pcco/4.png" alt="" /></li>
                <li><img src="@/assets/pcco/5.png" alt="" /></li>
                <li><img src="@/assets/pcco/6.png" alt="" /></li>
                <li><img src="@/assets/pcco/7.png" alt="" /></li>
                <li><img src="@/assets/pcco/8.png" alt="" /></li>
                <li><img src="@/assets/pcco/9.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcco/jj.png" alt="" /></li>
                <li><img src="@/assets/pcco/11.png" alt="" /></li>
                <li><img src="@/assets/pcco/12.png" alt="" /></li>
                <li><img src="@/assets/pcco/13.png" alt="" /></li>
                <li><img src="@/assets/pcco/14.png" alt="" /></li>
                <li><img src="@/assets/pcco/15.png" alt="" /></li>
                <li><img src="@/assets/pcco/16.png" alt="" /></li>
                <li><img src="@/assets/pcco/17.png" alt="" /></li>
                <li><img src="@/assets/pcco/18.png" alt="" /></li>
              </ul>
            </div>

            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/pcco/19.png" alt="" /></li>
                <li><img src="@/assets/pcco/20.png" alt="" /></li>
                <li><img src="@/assets/pcco/21.png" alt="" /></li>
                <li><img src="@/assets/pcco/22.png" alt="" /></li>
                <li><img src="@/assets/pcco/23.png" alt="" /></li>
                <li><img src="@/assets/pcco/24.png" alt="" /></li>
                <li><img src="@/assets/pcco/25.png" alt="" /></li>
                <li><img src="@/assets/pcco/26.png" alt="" /></li>
                <li><img src="@/assets/pcco/28.png" alt="" /></li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul>
                <li><img src="@/assets/moco/29.png" alt="" /></li>
              </ul>
            </div>
          </div>
          <br /><br />
          <!-- 如果需要分页器 -->
          <!-- <div class="swiper-pagination"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
    };
  },
  
  mounted() {
    let _this = this;
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      // loop: true, // 循环模式选项
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        // disableOnInteraction: false,
      },
      // autoplay: true,
      // delay:5000,
      // autoplayDisableOnInteraction : false,
      pagination: {
        el: "",
      },
      on: {
        slideChangeTransitionEnd: function () {
          var is = false;
          if (!is) {
            _this.activeIndex = this.activeIndex;
            is = true;
            setTimeout(() => {
              is = false;
            }, 5000);
          }
        },
      },
    });
    this.$nextTick(()=>{
      mySwiper[0].el.onmouseover = function(){
        // mySwiper[0].autoplay.delay = 1000
        mySwiper[0].autoplay.stop();
        // mySwiper[0].init()
      }
      mySwiper[0].el.onmouseout = function(){
        mySwiper[0].autoplay.start();
        // mySwiper[0].autoplay.delay = 5000
        // mySwiper[0].init()
      }
     })
  },
  methods: {
    initSize() {
      return document.body.clientWidth > 768;
    },
     onInit: function (swiper) {
    swiperAnimateCache(swiper); //隐藏动画元素
    swiperAnimate(swiper); //初始化完成开始动画
  },
  onSlideChangeEnd: function (swiper) {
    swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
  },
  },
};
</script>



<style scoped>
.home_con {
  position: relative;
}
.swiper-container {
  width: 100%;
}
.swiper-slide ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.swiper_in {
  width: 100%;
  background: #fff;
}
.swiper_mo {
  display: none;
  background: #fff;
}

.swiper_pc .swiper-slide ul li {
  width: 217px;
  height: 124px;
  margin-right:-20px;
}
.swiper_pc .swiper-slide ul li img {
  width: 100%;
  height: 100%;
}
.swiper_pc
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 30px;
  height: 3px;
  background: #0084ff;
}
.swiper_pc .swiper-pagination-bullet-active {
  background: #e7ecf3;
  width: 30px !important;
}
.pages {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 18px;
  height: 3px;
  display: flex;
  box-sizing: border-box;
  padding: 0 0 0 8px;
}
.pages li {
  position: relative;
  width: 30px;
  margin-right: 8px;
  height: 3px;
  background: #e7ecf3;
}
.pages li p {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0084ff;
  /* z-index: -1; */
  animation: slidetounlock 5s linear;
}
@keyframes slidetounlock {
  0% {
    width: 0px;
  }
  100% {
    width: 100%;
  }
}

@media screen and (max-width: 1440px) {
}
@media screen and (max-width: 768px) {
  .pages li {
    width: 15px;
  }
  .pages {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8%;
  height: 3px;
  display: flex;
  box-sizing: border-box;
  padding: 0 0 0 8px;
}
  .swiper_pc {
    display: none;
  }
  .swiper_mo {
    display: block;
  }
  .swiper_mo .swiper-slide ul li {
    width: 33%;
  }

  .swiper_mo .swiper-slide ul li img {
    width: 110px;
    height: 53px;
  }
  .swiper_mo
    .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    width: 15px;
    height: 3px;
    background: #0084ff;
    border-radius: 0;
    margin-top: 80px;
  }
  .swiper_mo .swiper-pagination-bullet-active {
    background: #e7ecf3;
    width: 15px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/swiper.vue